import React from 'react';
import { createPortal } from 'react-dom';
import PropTypes from 'prop-types';

import { usePortal } from './hooks';

const Portal = ({ children, ...rest }) => {
  const elementToMountTo = usePortal(rest);
  return createPortal(children, elementToMountTo);
};

export default Portal;

/* eslint-disable react/no-unused-prop-types, react/require-default-props */
Portal.propTypes = {
  children: PropTypes.node,
  mountNode: PropTypes.element,
  nodeType: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.func,
    PropTypes.element,
  ]),
  portalRef: PropTypes.oneOfType([PropTypes.shape({}), PropTypes.func]),
};

Portal.defaultProps = {
  children: null,
  nodeType: 'div',
};
/* eslint-enable react/no-unused-prop-types, react/require-default-props */
